// src/App.js
import React from "react";
import "./home.css"
const App = () => {
  return (
    <div className="page-container">
      <h2 className="title">sevenstair</h2>
    
    <div className="image-container">
        <img
        src="../images/homescreen.png"
        alt=""
        className="main-image"
        />
    </div>
    </div>
  );
};

export default App;
